import { EABFilterImplementationType, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import DLZFilterUI from "../ui/DLZFilterUI.vue";
import DLZFilterBadge from "../ui/badges/DLZFilterBadge.vue";

export default class DLZFilter implements EventFilter {
  constructor(
    public readonly definitionOfDLZInHours: number,
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = DLZFilterBadge;

  static readonly UI = DLZFilterUI;

  getEventFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_THROUGHPUT_TIME,
        value: {
          value: this.definitionOfDLZInHours,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
